import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Container, Button, TextField, MenuItem, DialogActions, Card, } from "@mui/material";
import { format } from "date-fns";
import HeaderSession from "../../../utils/headerSession";
import api from "../../../services/api";
import FazerObservacoes from "../../components/fazerObservacoes.";
import MessageError from "../../../messages/messageError";
import MessageSuccess from "../../../messages/messageSuccess";
import Loading from "../../../load/loading";
import { useSelector } from "react-redux";
import LoadingShort from "../../../load/loadingShort";
import ObservacoesFeitas from "../../departamentos/dlif/observacoesFeitas";
import DocumentViewer from "../../departamentos/dmts/importacaoExportacao/documentViewer";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import StatusSolicitacoes from "../../../utils/status/statusSolicitacoes";

interface Medicamento {
  status: string;
  nome: string;
  numeroRegisto: string;
  dciDosagem: string;
  apresentacao: string;
  areaTerapeutica: string;
  fabricante: string;
  titularAIM: string;
  createdAt: string;
  docs: [];
  observacoes: {
    length: number;
  };
}

const estados = ["Análise", "Aprovado", "Suspenso", "Reprovado"];

const MedicamentoDetalhe: React.FC = () => {
  const user = useSelector((state: any) => state?.account.user);
  const [medicamento, setMedicamento] = useState<Medicamento>();
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadStatus, setStatus] = useState(false);
  const [loadObs, setLoadObs] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [obs, setObs] = useState("");
  const [estado, setEstado] = useState("");
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    api.get(`/medicamento-aim/${id}`)
      .then((res) => {
        setMedicamento(res.data.medicamentoAIM)
      }).catch((err) => {
      }).finally(() => setIsLoading(false))
  }, [refreshPage])

  if (!medicamento) {
    return (
      <Box textAlign="center">
        <HeaderSession title="DETALHES DO MEDICAMENTO" />
        <Loading text="Carregando..." focus={''} />
      </Box>
    );
  }


  // const coresEstado: Record<string, string> = {
  //   "Análise": "#515151",
  //   "Aprovado": "#2e7d32",
  //   "Suspenso": "#ed6c02",
  //   "Reprovado": "#d32f2f",
  // };


  const handleChangeStatus = () => {
    setStatus(true);
    api.patch("/medicamento-aim/change-status", {
      medicamentoAIMId: id,
      status: estado,
      observacao: '',
      userId: user?._id
    })
      .then(() => {
        setSuccess("Estado actualizado!");
        setRefreshPage((prev) => !prev);
        setEstado("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setStatus(false));
  };

  const handleObservacao = () => {
    setLoadObs(true);
    api.patch("/medicamento-aim/add-observacao", {
      medicamentoAIMId: id,
      content: obs,
      userId: user?._id
    })
      .then(() => {
        setSuccess("Observação adicionada!");
        setRefreshPage((prev) => !prev)
        setObs("");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setLoadObs(false));
  };

  return (
    <Container
      maxWidth="md"
      sx={{ display: "flex", flexDirection: "column", }}>
      <HeaderSession title="DETALHES DO MEDICAMENTO" />

      <Card sx={{ padding: 2 }}>
        <HeaderGestorConfigs title='Informações Gerais' />

        {error && (<MessageError message={error} />)}
        {success && <MessageSuccess message={success} />}

        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 2, mb: 2 }}>
          <Typography variant="body1">
            <strong>Estado:</strong>
            <StatusSolicitacoes status={medicamento?.status} />
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: 'column', gap: 0.5 }}>
          <Typography variant="body1">
            <strong>Número de Registo:</strong> {medicamento?.numeroRegisto}
          </Typography>
          <Typography variant="body1">
            <strong>Nome:</strong> {medicamento?.nome}
          </Typography>
          <Typography variant="body1">
            <strong>DCI - Dosagem:</strong> {medicamento?.dciDosagem || "—"}
          </Typography>
          <Typography variant="body1">
            <strong>Apresentação:</strong> {medicamento?.apresentacao}
          </Typography>
          <Typography variant="body1">
            <strong>Área Terapêutica:</strong> {medicamento?.areaTerapeutica}
          </Typography>
          <Typography variant="body1">
            <strong>Fabricante:</strong> {medicamento?.fabricante}
          </Typography>
          <Typography variant="body1">
            <strong>Titular AIM:</strong> {medicamento?.titularAIM}
          </Typography>
          <Typography variant="body1">
            <strong>Data de Registo:</strong>{" "}
            {format(new Date(medicamento?.createdAt), "dd/MM/yyyy")}
          </Typography>
        </Box>
      </Card>

      <br />
      <Card sx={{ padding: 2 }}>
        <HeaderGestorConfigs title='Gestão de Estado' />

        <TextField
          label="Estado do Medicamento"
          select
          size="small"
          defaultValue={medicamento?.status}
          onChange={(e) => setEstado(e.target.value)}
          fullWidth
        >
          {estados.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        {estado &&
          <FazerObservacoes
            setObs={setObs}
            obs={obs}
            titulo="(Descreve aqui as observaçōes"
          />
        }
        <DialogActions>
          <Button variant="outlined"
            color="error"
            onClick={() => {
              setEstado("");
              setObs("");
            }}>Cancelar</Button>
          <Button disabled={!obs} style={{ backgroundColor: '#85287e' }} variant="contained"
            onClick={() => { handleChangeStatus(); handleObservacao(); }}>{loadObs ? <LoadingShort text={'Salvando'} /> : "Salvar"}</Button>
        </DialogActions>
      </Card>

      <br />
      {medicamento?.docs &&
        <Card style={{ padding: 20 }}>
          {/* <DocumentViewer pdfUrls={medicamento?.docs} title={'DOCUMENTOS ANEXADOS'} /> */}
        </Card>
      }
      <br />
      {medicamento.observacoes.length > 0 && <ObservacoesFeitas observacoesFeitas={medicamento.observacoes} />}

    </Container>

  );
};

export default MedicamentoDetalhe;
